"use strict";

exports.__esModule = true;
exports.EditableTabElement = EditableTabElement;
var _react = _interopRequireDefault(require("react"));
var _Grid = require("../Grid");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Displays an editable tab.
 */
function EditableTabElement(props) {
  var _props$width = props.width,
    width = _props$width === void 0 ? 1024 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 768 : _props$height;
  return /*#__PURE__*/_react["default"].createElement(_Grid.EditableGridElement, _extends({}, props, {
    width: width,
    height: height
  }));
}